import React from 'react';
import { useLocation } from 'react-router-dom';
import Alert from 'Components/Alert';
import FieldSet from 'Components/FieldSet';
import LoadingIndicator from 'Components/Loading/LoadingIndicator';
import PageContent from 'Components/Page/PageContent';
import PageContentBody from 'Components/Page/PageContentBody';
import Table from 'Components/Table/Table';
import TableBody from 'Components/Table/TableBody';
import TableRow from 'Components/Table/TableRow';
import TableRowCell from '../components/TdarrTableRowCell';
import { kinds } from 'Helpers/Props';
import { fileName, formatMegabytes } from '../format';
import { useTdarrLibraries, useTdarrSearch } from '../queries';

const columns = [
  { name: 'file', label: 'File', isVisible: true, isSortable: false },
  { name: 'library', label: 'Library', isVisible: true, isSortable: false },
  { name: 'video', label: 'Video', isVisible: true, isSortable: false },
  { name: 'resolution', label: 'Resolution', isVisible: true, isSortable: false },
  { name: 'audio', label: 'Audio', isVisible: true, isSortable: false },
  { name: 'container', label: 'Container', isVisible: true, isSortable: false },
  { name: 'size', label: 'Size', isVisible: true, isSortable: false },
  { name: 'transcode', label: 'Transcode', isVisible: true, isSortable: false },
  { name: 'health', label: 'Health Check', isVisible: true, isSortable: false }
];

export default function Search() {
  const location = useLocation();
  const searchTerm = new URLSearchParams(location.search).get('q')?.trim() ?? '';
  const results = useTdarrSearch(searchTerm);
  const libraries = useTdarrLibraries();
  const libraryNames = new Map(libraries.data?.map((library) => [library._id, library.name]) ?? []);
  return <PageContent title="Search"><PageContentBody><FieldSet legend={searchTerm ? `Search Results for “${searchTerm}”` : 'Search'}>
    {!searchTerm && <Alert>Enter a file name or path in the header search field and press Enter.</Alert>}
    {results.isPending && searchTerm && <LoadingIndicator />}
    {results.isError && <Alert kind={kinds.DANGER}>Tdarr search failed.</Alert>}
    {results.isSuccess && !results.data.length && <Alert>No matching media files were found.</Alert>}
    {!!results.data?.length && <Table columns={columns}><TableBody>{results.data.map((item) => <TableRow key={item._id}>
      <TableRowCell className="tdarr-path" title={item.file}>{fileName(item.file)}</TableRowCell>
      <TableRowCell>{libraryNames.get(item.DB ?? '') ?? item.DB ?? '—'}</TableRowCell>
      <TableRowCell>{item.video_codec_name ?? '—'}</TableRowCell><TableRowCell>{item.video_resolution ?? '—'}</TableRowCell>
      <TableRowCell>{item.audio_codec_name ?? '—'}</TableRowCell><TableRowCell>{item.container ?? '—'}</TableRowCell>
      <TableRowCell>{formatMegabytes(item.file_size)}</TableRowCell><TableRowCell>{item.TranscodeDecisionMaker ?? '—'}</TableRowCell>
      <TableRowCell>{item.HealthCheck ?? '—'}</TableRowCell>
    </TableRow>)}</TableBody></Table>}
  </FieldSet></PageContentBody></PageContent>;
}
